import React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../store/actions'
import DaneIdentyfikacyjneStyle from '../../styles/DaneIdentyfikacyjneStyle'
import MainStyle from '../../styles/MainStyle'

import IdentyfikacjaPodmiotu from '../../components/daneIdentyfikacyjne/IdentyfikacjaPodmiotu'
import IdentyfikacjaPodmiotuV12 from '../../components/daneIdentyfikacyjne/IdentyfikacjaPodmiotuV12'
import IdentyfikacjaPodmiotuR2 from '../../components/daneIdentyfikacyjne/IdentyfikacjaPodmiotuR2'
import IdentyfikacjaPodmiotuKulturyV12 from '../../components/daneIdentyfikacyjne/IdentyfikacjaPodmiotuKulturyV12'
import IdentyfikacjaPodmiotuKulturyR2 from '../../components/daneIdentyfikacyjne/IdentyfikacjaPodmiotuKulturyR2'
import IdentyfikacjaPodmiotuSkrocona from '../../components/daneIdentyfikacyjne/IdentyfikacjaPodmiotuSkrocona'
import IdentyfikacjaPodmiotuSkroconaV12 from '../../components/daneIdentyfikacyjne/IdentyfikacjaPodmiotuSkroconaV12'
import IdentyfikacjaPodmiotuSkroconaR2 from '../../components/daneIdentyfikacyjne/IdentyfikacjaPodmiotuSkroconaR2'
import IdentyfikacjaDomuMaklerskiego from '../../components/daneIdentyfikacyjne/IdentyfikacjaDomuMaklerskiego'
import IdentyfikacjaDomuMaklerskiegoV12 from '../../components/daneIdentyfikacyjne/IdentyfikacjaDomuMaklerskiegoV12'
import IdentyfikacjaDomuMaklerskiegoR2 from '../../components/daneIdentyfikacyjne/IdentyfikacjaDomuMaklerskiegoR2'
import InformacjeJednostkaDominujaca from '../../components/daneIdentyfikacyjne/InformacjeJednostkaDominujaca'
import InformacjeJednostkaDominujacaV12 from '../../components/daneIdentyfikacyjne/InformacjeJednostkaDominujacaV12'
import Siedziba from '../../components/daneIdentyfikacyjne/Siedziba'
import SiedzibaR2 from '../../components/daneIdentyfikacyjne/SiedzibaR2'
import Adres from '../../components/daneIdentyfikacyjne/Adres'
import AdresZagraniczny from '../../components/daneIdentyfikacyjne/AdresZagraniczny'
import ZakresDzialalnosciDM from '../../components/daneIdentyfikacyjne/ZakresDzialalnosciDM'
import Progress from '../../components/controls/Progress'
import ErrorDialog from '../../components/ErrorDialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'

class DaneIdentyfikacyjne extends React.Component {
  state = { gusError: false, gusServerError: false }

  gusErrorContent() {
    return (
      <DialogContent>
        <DialogContentText>
          Przykro nam, ale nie udało się pobrać danych z serwera GUS.
        </DialogContentText>
        <br />
        <DialogContentText>
          Zweryfikuj wprowadzony NIP/Numer KRS i spróbuj ponownie.
        </DialogContentText>
      </DialogContent>
    )
  }

  gusServerErrorContent() {
    return (
      <DialogContent>
        <DialogContentText>
          Przykro nam, ale nie udało się pobrać danych z serwera GUS.
        </DialogContentText>
        <br />
        <DialogContentText>
          W chwili obecnej serwer GUS nie odpowiada.
        </DialogContentText>
        <br />
        <DialogContentText>Spróbuj ponownie za chwilę.</DialogContentText>
      </DialogContent>
    )
  }

  loadGUSData(gusData, uzupelnijNIPKRS, dane, poleNIP, poleKRS) {
    const {
      onSetName,
      onSetSectionData,
      onSetGUSLoading,
      sectionList,
    } = this.props
    const { daneGUS, danePKD, gusServerError } = gusData
    if (daneGUS && danePKD) {
      let wpiszKodyPKD = true
      let wpiszNazweDzialalnosciPKD = false
      let index = sectionList.indexOf(
        sectionList.find((s) => s.TypSekcji === 'IdentyfikacjaPodmiotu'),
      )
      if (index === -1)
        index = sectionList.indexOf(
          sectionList.find((s) => s.TypSekcji === 'IdentyfikacjaPodmiotu_v1_2'),
        )
      if (index === -1)
        index = sectionList.indexOf(
          sectionList.find((s) => s.TypSekcji === 'IdentyfikacjaPodmiotu_r2'),
        )
      if (index === -1)
        index = sectionList.indexOf(
          sectionList.find(
            (s) => s.TypSekcji === 'IdentyfikacjaPodmiotuKultury_v1_2',
          ),
        )
      if (index === -1)
        index = sectionList.indexOf(
          sectionList.find(
            (s) => s.TypSekcji === 'IdentyfikacjaPodmiotuKultury_r2',
          ),
        )
      if (index === -1) {
        index = sectionList.indexOf(
          sectionList.find(
            (s) => s.TypSekcji === 'IdentyfikacjaPodmiotuSkrocona',
          ),
        )
        if (index === -1)
          if (index !== -1) {
            wpiszKodyPKD = false
            wpiszNazweDzialalnosciPKD = false
          }
      }
      if (index === -1) {
        index = sectionList.indexOf(
          sectionList.find(
            (s) => s.TypSekcji === 'IdentyfikacjaPodmiotuSkrocona_v1_2',
          ),
        )
        if (index !== -1) {
          wpiszKodyPKD = false
          wpiszNazweDzialalnosciPKD = false
        }
      }
      if (index === -1) {
        index = sectionList.indexOf(
          sectionList.find(
            (s) => s.TypSekcji === 'IdentyfikacjaPodmiotuSkrocona_r2',
          ),
        )
        if (index !== -1) {
          wpiszKodyPKD = false
          wpiszNazweDzialalnosciPKD = false
        }
      }
      if (index === -1) {
        index = sectionList.indexOf(
          sectionList.find(
            (s) => s.TypSekcji === 'IdentyfikacjaDomuMaklerskiego',
          ),
        )
        if (index !== -1) {
          wpiszKodyPKD = false
          wpiszNazweDzialalnosciPKD = false
        }
      }
      if (index === -1) {
        index = sectionList.indexOf(
          sectionList.find(
            (s) => s.TypSekcji === 'IdentyfikacjaDomuMaklerskiego_v1_2',
          ),
        )
        if (index !== -1) {
          wpiszKodyPKD = false
          wpiszNazweDzialalnosciPKD = false
        }
      }
       if (index === -1) {
        index = sectionList.indexOf(
          sectionList.find(
            (s) => s.TypSekcji === 'IdentyfikacjaDomuMaklerskiego_r2',
          ),
        )
        if (index !== -1) {
          wpiszKodyPKD = false
          wpiszNazweDzialalnosciPKD = false
        }
      }     if (index === -1) {
        index = sectionList.indexOf(
          sectionList.find(
            (s) => s.TypSekcji === 'InformacjeJednostkaDominujaca',
          ),
        )
        if (index !== -1) {
          wpiszKodyPKD = false
          wpiszNazweDzialalnosciPKD = true
        }
      }
      if (index === -1) {
        index = sectionList.indexOf(
          sectionList.find(
            (s) => s.TypSekcji === 'InformacjeJednostkaDominujaca_v1_2',
          ),
        )
        if (index !== -1) {
          wpiszKodyPKD = false
          wpiszNazweDzialalnosciPKD = true
        }
      }
      if (index !== -1) {
        onSetSectionData('NazwaFirmy', daneGUS.NazwaPelna, index)
        onSetName(daneGUS.NazwaPelna)
        if (uzupelnijNIPKRS) {
          if (!dane[poleNIP]) onSetSectionData(poleNIP, daneGUS.NIP, index)
          else if (!dane[poleKRS])
            onSetSectionData(poleKRS, daneGUS.Rejestr.Numer, index)
        }
        const pkdList = Array.isArray(danePKD.PKD) ? danePKD.PKD : []
        const pkd2007List = Array.isArray(danePKD.PKD2007)
          ? danePKD.PKD2007
          : []
        const pkd2025Codes = new Set()
        const pkd2007Codes = new Set()
        pkdList.forEach((k) => {
          const version = String(k.WersjaPkd || '').trim()
          if (version === '2007') pkd2007Codes.add(k.Kod)
          else pkd2025Codes.add(k.Kod)
        })
        pkd2007List.forEach((k) => pkd2007Codes.add(k.Kod))
        if (wpiszKodyPKD) {
          const daneSekcji = sectionList[index] ? sectionList[index].Dane : null
          const hasPKD2007 =
            daneSekcji &&
            Object.prototype.hasOwnProperty.call(daneSekcji, 'PKD2007')
          if (hasPKD2007) {
            onSetSectionData('PKD', Array.from(pkd2025Codes), index)
            onSetSectionData('PKD2007', Array.from(pkd2007Codes), index)
          } else {
            const allPKD = new Set([...pkd2025Codes, ...pkd2007Codes])
            onSetSectionData('PKD', Array.from(allPKD), index)
          }
        }
        if (wpiszNazweDzialalnosciPKD) {
          if (pkdList.length) {
            const podstawowyPrzedmiot =
              pkdList.find((k) => k.Przewazajaca) || pkdList[0]
            onSetSectionData(
              'PrzedmiotDzialalnosci',
              podstawowyPrzedmiot.Nazwa,
              index,
            )
          } else onSetSectionData('PrzedmiotDzialalnosci', null, index)
        }
      }

      index = sectionList.indexOf(
        sectionList.find((s) => s.TypSekcji === 'Siedziba'),
      )
      if (index !== -1) {
        onSetSectionData(
          'Wojewodztwo',
          daneGUS.AdresSiedziby.Wojewodztwo,
          index,
        )
        onSetSectionData('Powiat', daneGUS.AdresSiedziby.Powiat, index)
        onSetSectionData('Gmina', daneGUS.AdresSiedziby.Gmina, index)
        onSetSectionData(
          'Miejscowosc',
          daneGUS.AdresSiedziby.Miejscowosc,
          index,
        )
      }

      index = sectionList.indexOf(
        sectionList.find((s) => s.TypSekcji === 'Siedziba_r2'),
      )
      if (index !== -1) {
        onSetSectionData('SiedzibaZagraniczna', false, index)
        onSetSectionData(
          'Wojewodztwo',
          daneGUS.AdresSiedziby.Wojewodztwo,
          index,
        )
        onSetSectionData('Powiat', daneGUS.AdresSiedziby.Powiat, index)
        onSetSectionData('Gmina', daneGUS.AdresSiedziby.Gmina, index)
        onSetSectionData('Ulica', daneGUS.AdresSiedziby.Ulica, index)
        onSetSectionData('NrDomu', daneGUS.AdresSiedziby.NrDomu, index)
        onSetSectionData('NrLokalu', daneGUS.AdresSiedziby.NrLokalu, index)
        onSetSectionData(
          'Miejscowosc',
          daneGUS.AdresSiedziby.Miejscowosc,
          index,
        )
        let kod = daneGUS.AdresSiedziby.KodPocztowy
        if (kod && kod.length === 5)
          kod = kod.substring(0, 2) + '-' + kod.substring(2, 5)
        onSetSectionData('KodPocztowy', kod, index)
        if (
          daneGUS.AdresSiedziby.Kraj &&
          daneGUS.AdresSiedziby.Kraj.toUpperCase() === 'POLSKA'
        )
          onSetSectionData('KodKraju', 'PL', index)
      }

      index = sectionList.indexOf(
        sectionList.find(
          (s) => s.TypSekcji === 'Adres' || s.TypSekcji === 'Adres_v1_2',
        ),
      )
      if (index !== -1) {
        onSetSectionData(
          'Wojewodztwo',
          daneGUS.AdresSiedziby.Wojewodztwo,
          index,
        )
        onSetSectionData('Powiat', daneGUS.AdresSiedziby.Powiat, index)
        onSetSectionData('Gmina', daneGUS.AdresSiedziby.Gmina, index)
        onSetSectionData('Ulica', daneGUS.AdresSiedziby.Ulica, index)
        onSetSectionData('NrDomu', daneGUS.AdresSiedziby.NrDomu, index)
        onSetSectionData('NrLokalu', daneGUS.AdresSiedziby.NrLokalu, index)
        onSetSectionData(
          'Miejscowosc',
          daneGUS.AdresSiedziby.Miejscowosc,
          index,
        )
        let kod = daneGUS.AdresSiedziby.KodPocztowy
        if (kod && kod.length === 5)
          kod = kod.substring(0, 2) + '-' + kod.substring(2, 5)
        onSetSectionData('KodPocztowy', kod, index)
        onSetSectionData('Poczta', daneGUS.AdresSiedziby.Poczta, index)
        if (
          daneGUS.AdresSiedziby.Kraj &&
          daneGUS.AdresSiedziby.Kraj.toUpperCase() === 'POLSKA'
        )
          onSetSectionData('KodKraju', 'PL', index)
      }
    } else {
      this.setState({ gusError: true, gusServerError })
    }
    onSetGUSLoading(false)
  }

  render() {
    const {
      sectionList,
      onLoadGUS,
      onSetName,
      validityErrors,
      onSetSectionData,
      onSetKRS,
      isGUSLoading,
      czyPodsumowanie,
    } = this.props
    return (
      <MainStyle>
        <DaneIdentyfikacyjneStyle>
          {sectionList.map((data, index) => {
            switch (data.TypSekcji) {
              case 'IdentyfikacjaPodmiotu':
                return (
                  <IdentyfikacjaPodmiotu
                    key={index}
                    data={data.Dane}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                    onSetName={onSetName}
                    onSetKRS={onSetKRS}
                    isGUSLoading={isGUSLoading}
                    onLoadGUS={(czyKRS, identyfikator) => {
                      onLoadGUS(czyKRS, identyfikator).then((gusData) => {
                        this.loadGUSData(gusData)
                      })
                    }}
                  />
                )
              case 'IdentyfikacjaPodmiotu_v1_2':
                return (
                  <IdentyfikacjaPodmiotuV12
                    key={index}
                    data={data.Dane}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                    onSetName={onSetName}
                    isGUSLoading={isGUSLoading}
                    onLoadGUS={(identyfikator) => {
                      onLoadGUS(false, identyfikator).then((gusData) => {
                        this.loadGUSData(
                          gusData,
                          true,
                          data.Dane,
                          'NrNIP',
                          'NrKRS',
                        )
                      })
                    }}
                  />
                )
              case 'IdentyfikacjaPodmiotu_r2':
                return (
                  <IdentyfikacjaPodmiotuR2
                    key={index}
                    data={data.Dane}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                    onSetName={onSetName}
                    isGUSLoading={isGUSLoading}
                    onLoadGUS={(identyfikator) => {
                      onLoadGUS(false, identyfikator).then((gusData) => {
                        this.loadGUSData(
                          gusData,
                          true,
                          data.Dane,
                          'NrNIP',
                          'NrKRS',
                        )
                      })
                    }}
                  />
                )                
              case 'IdentyfikacjaPodmiotuKultury_v1_2':
                return (
                  <IdentyfikacjaPodmiotuKulturyV12
                    key={index}
                    data={data.Dane}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                    onSetName={onSetName}
                    isGUSLoading={isGUSLoading}
                    onLoadGUS={(identyfikator) => {
                      onLoadGUS(false, identyfikator).then((gusData) => {
                        this.loadGUSData(
                          gusData,
                          true,
                          data.Dane,
                          'NrNIP',
                          'NrKRS',
                        )
                      })
                    }}
                  />
                )
              case 'IdentyfikacjaPodmiotuKultury_r2':
                return (
                  <IdentyfikacjaPodmiotuKulturyR2
                    key={index}
                    data={data.Dane}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                    onSetName={onSetName}
                    isGUSLoading={isGUSLoading}
                    onLoadGUS={(identyfikator) => {
                      onLoadGUS(false, identyfikator).then((gusData) => {
                        this.loadGUSData(
                          gusData,
                          true,
                          data.Dane,
                          'NrNIP',
                          'NrKRS',
                        )
                      })
                    }}
                  />
                )
              case 'IdentyfikacjaDomuMaklerskiego':
                return (
                  <IdentyfikacjaDomuMaklerskiego
                    key={index}
                    data={data.Dane}
                    errors={this.props.validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    onLoadGUS={(czyKRS, identyfikator) => {
                      onLoadGUS(czyKRS, identyfikator).then((gusData) =>
                        this.loadGUSData(gusData),
                      )
                    }}
                    onSetSectionData={(name, value) =>
                      this.props.onSetSectionData(name, value, index)
                    }
                    onSetName={onSetName}
                  />
                )
              case 'IdentyfikacjaDomuMaklerskiego_v1_2':
                return (
                  <IdentyfikacjaDomuMaklerskiegoV12
                    key={index}
                    data={data.Dane}
                    errors={this.props.validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    onLoadGUS={(czyKRS, identyfikator) => {
                      onLoadGUS(czyKRS, identyfikator).then((gusData) =>
                        this.loadGUSData(
                          gusData,
                          true,
                          data.Dane,
                          'NIP',
                          'KRS',
                        ),
                      )
                    }}
                    onSetSectionData={(name, value) =>
                      this.props.onSetSectionData(name, value, index)
                    }
                    onSetName={onSetName}
                  />
                )                
              case 'IdentyfikacjaDomuMaklerskiego_r2':
                return (
                  <IdentyfikacjaDomuMaklerskiegoR2
                    key={index}
                    data={data.Dane}
                    errors={this.props.validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    onLoadGUS={(czyKRS, identyfikator) => {
                      onLoadGUS(czyKRS, identyfikator).then((gusData) =>
                        this.loadGUSData(
                          gusData,
                          true,
                          data.Dane,
                          'NIP',
                          'KRS',
                        ),
                      )
                    }}
                    onSetSectionData={(name, value) =>
                      this.props.onSetSectionData(name, value, index)
                    }
                    onSetName={onSetName}
                  />
                )                 
              case 'IdentyfikacjaPodmiotuSkrocona':
                return (
                  <IdentyfikacjaPodmiotuSkrocona
                    key={index}
                    data={data.Dane}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                    onLoadGUS={(czyKRS, identyfikator) => {
                      onLoadGUS(czyKRS, identyfikator).then((gusData) =>
                        this.loadGUSData(gusData),
                      )
                    }}
                    onSetKRS={onSetKRS}
                    onSetName={onSetName}
                  />
                )
              case 'IdentyfikacjaPodmiotuSkrocona_v1_2':
                return (
                  <IdentyfikacjaPodmiotuSkroconaV12
                    key={index}
                    data={data.Dane}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                    onLoadGUS={(identyfikator) => {
                      onLoadGUS(false, identyfikator).then((gusData) =>
                        this.loadGUSData(
                          gusData,
                          true,
                          data.Dane,
                          'NrNIP',
                          'NrKRS',
                        ),
                      )
                    }}
                    onSetName={onSetName}
                  />
                )
              case 'IdentyfikacjaPodmiotuSkrocona_r2':
                return (
                  <IdentyfikacjaPodmiotuSkroconaR2
                    key={index}
                    data={data.Dane}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                    onLoadGUS={(identyfikator) => {
                      onLoadGUS(false, identyfikator).then((gusData) =>
                        this.loadGUSData(
                          gusData,
                          true,
                          data.Dane,
                          'NrNIP',
                          'NrKRS',
                        ),
                      )
                    }}
                    onSetName={onSetName}
                  />
                )
              case 'InformacjeJednostkaDominujaca':
                return (
                  <InformacjeJednostkaDominujaca
                    key={index}
                    data={data.Dane}
                    errors={this.props.validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    onLoadGUS={(czyKRS, identyfikator) => {
                      onLoadGUS(czyKRS, identyfikator).then((gusData) =>
                        this.loadGUSData(gusData),
                      )
                    }}
                    onSetSectionData={(name, value) =>
                      this.props.onSetSectionData(name, value, index)
                    }
                  />
                )
              case 'InformacjeJednostkaDominujaca_v1_2':
                return (
                  <InformacjeJednostkaDominujacaV12
                    key={index}
                    data={data.Dane}
                    errors={this.props.validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    onLoadGUS={(czyKRS, identyfikator) => {
                      onLoadGUS(czyKRS, identyfikator).then((gusData) =>
                        this.loadGUSData(
                          gusData,
                          true,
                          data.Dane,
                          'NIP',
                          'KRS',
                        ),
                      )
                    }}
                    onSetSectionData={(name, value) =>
                      this.props.onSetSectionData(name, value, index)
                    }
                  />
                )
              case 'Siedziba':
                return (
                  <Siedziba
                    key={index}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    data={data.Dane}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                  />
                )
              case 'Siedziba_r2':
                return (
                  <SiedzibaR2
                    key={index}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    data={data.Dane}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                  />
                )
              case 'Adres':
              case 'Adres_v1_2':
                return (
                  <Adres
                    key={index}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    data={data.Dane}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                  />
                )
              case 'SiedzibaZagraniczna':
              case 'SiedzibaZagraniczna_v1_2':
                return (
                  <AdresZagraniczny
                    key={index}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    data={data.Dane}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                  />
                )
              case 'ZakresDzialalnosciDM':
                return (
                  <ZakresDzialalnosciDM
                    key={index}
                    errors={this.props.validityErrors.filter(
                      (value) => value.TypSekcji === data.TypSekcji,
                    )}
                    data={data.Dane}
                    onSetSectionData={(name, value) =>
                      this.props.onSetSectionData(name, value, index)
                    }
                    czyPodsumowanie={czyPodsumowanie}
                  />
                )
              default:
                return null
            }
          })}
        </DaneIdentyfikacyjneStyle>
        <Progress
          isOpen={isGUSLoading}
          progressText="Trwa pobieranie danych z GUS..."
        />
        <ErrorDialog
          error={this.state.gusError}
          title={'Nie udało się pobrać danych z GUS'}
          content={
            this.state.gusServerError
              ? this.gusServerErrorContent()
              : this.gusErrorContent()
          }
          onCloseDialog={() =>
            this.setState({ gusError: false, gusServerError: false })
          }
        />
      </MainStyle>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    validityErrors: state.sprawozdanie.validityErrors
      ? state.sprawozdanie.validityErrors
      : [],
    isGUSLoading: state.sprawozdanie.isGUSLoading,
    czyPodsumowanie: state.sprawozdanie.czyPodsumowanie,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSetSectionData: (name, value, index) =>
      dispatch(actions.setSectionData(name, value, index)),
    onSetGUSLoading: (isGUSLoading) =>
      dispatch(actions.setGUSLoading(isGUSLoading)),
    onLoadGUS: (czyKRS, identyfikator) =>
      dispatch(actions.loadGUS(czyKRS, identyfikator, true)),
    onSetName: (name) => dispatch(actions.setName(name)),
    onSetKRS: (value) => dispatch(actions.setCzyKRS(value)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DaneIdentyfikacyjne)
